import { render, staticRenderFns } from "./WechatConfig.vue?vue&type=template&id=4a66567c&scoped=true"
import script from "./WechatConfig.vue?vue&type=script&lang=js"
export * from "./WechatConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a66567c",
  null
  
)

export default component.exports